import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { volumeBenefits } from '../../data/salesContent';
export function VolumeBenefitsSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-208" data-mp="hvnvdl8u7l0o">
      <div className="mx-auto max-w-6xl" data-id="element-209" data-mp="wnokvhdddq9w">
        <SectionHeading title="Cada volumen está pensado para que puedas volver a usarlo" data-id="element-210" data-mp="wopy9shuyous" />
        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-211" data-mp="rttszqnm24zq">
          {volumeBenefits.map(({
          title,
          body,
          icon: Icon
        }) => <li key={title} className="flex flex-col rounded-2xl border border-ink-line bg-ink-raised p-7" data-id="element-212" data-mp="11kohz2s8riov">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-gold/40 text-gold" data-id="element-213" data-mp="1fk6btwke9m53">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-214" data-mp="1an7ez69cj137" />
              </span>
              <h3 className="mt-5 font-display text-lg font-extrabold uppercase leading-snug text-cream md:text-xl" data-id="element-215" data-mp="3hddzpue2pc2l">{title}</h3>
              <p className="mt-3 text-base leading-relaxed text-neutral-400 md:text-lg" data-id="element-216" data-mp="3cfvlbohae4n7">{body}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}